import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react'
import { format } from 'date-fns'
import React, { useCallback, useState } from 'react'
import { REPOSITORY } from '../../../../api/repository/Repository'
import CustomDatePicker from '../../../../components/CustomDatePicker/CustomDatePicker'
import ConsumptionReport from './ConsumptionReport'
import { useRequestStatusContext } from './../../../../utils/hooks/Context/RequestStatusContext'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import Selector from '../../../../components/Selector/Selector'
import useButtonSelector from '../../../../utils/hooks/useButtonSelector/useButtonSelector'

const options = [
  {
    id: 0,
    value: 'excel',
    label: 'Excel',
  },
  {
    id: 1,
    value: 'pdf',
    label: 'PDF',
  },
]

export default function CompanyConsumption() {
  const { selected, onSelectedChange } = useButtonSelector(options)
  const [data, setData] = useState(null)
  const [filterData, setFilterData] = useState({})
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()
  const handleGetNNData = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .companyConsumptionReport(filterData.dDesde, filterData.dHasta)
      .then((res) => setData(res.data))
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle(error.response.data.error, error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
    handleCLoseLoading()
  }

  const handleGetReport = async () => {
    if (!selected) return

    const extension = selected.value === 'pdf' ? 'pdf' : 'xlsx'

    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .companyConsumptionExport(
        filterData.dDesde,
        filterData.dHasta,
        selected.value,
      )
      .then((res) => {
        handleCLoseLoading()
        const url = URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Consumo_empresa.${extension}`)
        document.body.appendChild(link)
        link.click()
        handleSetTitle('Reporte descargado con exito', 200)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            Continuar
          </Button>,
        )
        handleOpen()
        handleCLoseLoading()
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle('No se pudo exportar el reporte.', error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
  }

  const handleChangeFrom = useCallback((date) => {
    setFilterData((prevState) => ({
      ...prevState,
      dDesde: date ? format(date, 'dd-MM-yyyy') : null,
    }))
  }, [])
  const handleChangeTo = useCallback((date) => {
    setFilterData((prevState) => ({
      ...prevState,
      dHasta: date ? format(date, 'dd-MM-yyyy') : null,
    }))
  }, [])
  return (
    <VStack alignItems="flex-start">
      <HStack alignItems="flex-end">
        <VStack alignItems="flex-start" justifyContent="flex-start">
          <Text variant="subtitle2">Desde</Text>
          <Box border="1px solid #D7D7D7" maxW="150px" minW="150px">
            <CustomDatePicker
              maxDate={new Date()}
              onChange={handleChangeFrom}
              placeholder="dd/mm/aaaa"
            />
          </Box>
        </VStack>
        <VStack alignItems="flex-start" justifyContent="flex-start">
          <Text variant="subtitle2">Hasta</Text>
          <Box border="1px solid #D7D7D7" maxW="150px" minW="150px">
            <CustomDatePicker
              maxDate={new Date()}
              onChange={handleChangeTo}
              placeholder="dd/mm/aaaa"
            />
          </Box>
        </VStack>
        <VStack paddingStart={5}>
          <Button borderRadius={10} onClick={handleGetNNData}>
            Buscar
          </Button>
        </VStack>
      </HStack>
      {data && (
        <HStack alignItems="flex-end" paddingTop={5}>
          <VStack alignItems="flex-start">
            <Text variant="body2" fontWeight="bold">
              Descargar en formato
            </Text>
            <Box w="200px">
              <Selector
                isClearable
                options={options}
                onChange={onSelectedChange}
              />
            </Box>
          </VStack>
          <VStack paddingStart={5}>
            <Button onClick={handleGetReport}>Descargar informe</Button>
          </VStack>
          <VStack>
            <ConsumptionReport data={data} />
          </VStack>
        </HStack>
      )}
    </VStack>
  )
}
